import { endpoint } from 'constants/endpoint';
import { Request, hideLoader } from 'services/api/network';

// The S3 image buckets (user avatars, model and version screenshots) are
// private: objects can only be fetched through short-lived signed URLs issued
// by the assets-service via the gateway.

export const getSignedImageUrl = async (fileName) => {
  try {
    const response = await Request.get(
      `${endpoint.getSignedImageUrl}/${fileName}/getSignedUrl`,
      hideLoader
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    return null;
  }
  return null;
};

// Signed avatar URLs are cached per user so lists (collaborators, activity
// feeds) don't refetch the same avatar on every render. The backend signs for
// ~27h; refresh well before that.
const avatarCache = new Map(); // userId -> { url, expiresAt }
const AVATAR_CACHE_MS = 1000 * 60 * 60 * 12;

export const resolveAvatarUrl = async (user) => {
  if (!user?._id || user?.hasAvatar === false) return null;
  const cached = avatarCache.get(user._id);
  if (cached && Date.now() < cached.expiresAt) {
    return cached.url;
  }
  const imageObject = await getSignedImageUrl(`users_${user._id}`);
  const url = imageObject?.signed_request || null;
  // Failed lookups are cached too (short TTL) so a list of users with broken
  // avatars doesn't refire the request on every render.
  avatarCache.set(user._id, {
    url,
    expiresAt: Date.now() + (url ? AVATAR_CACHE_MS : 60_000)
  });
  return url;
};

export const clearAvatarCache = (userId) => {
  if (userId) avatarCache.delete(userId);
  else avatarCache.clear();
};
